import React, { useState, useEffect, useRef } from 'react';
import { Box, Tooltip, Typography, Autocomplete, TextField, Modal, RadioGroup, FormControlLabel, Radio, Button, IconButton, Menu, MenuItem, ListItem, ListItemText, Paper, Divider } from '@mui/material';
import '../../../FrontOffice/IPPatients/PatientsDetails/ClinicalNotes/DoctorNotes.css';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { clearCachevalue, localGetItem, setCachevalue, getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { CommonPatientDetails, ConfirmPopup, ConsultantPatientCard, DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import { Colors } from '../../../../Styles/Colors';
import { renderCorpInsuranceCard, formatDateTime } from '../../../../Components/CommonFunctions/CommonFunctions';
import { DataGrid } from '@mui/x-data-grid';
import { useHistory } from "react-router-dom";
import { ActionButton, renderIconButton, TemplatePopup } from "./SarasCommonComp";
import { DateTime } from 'luxon';
import ErrorIcon from '@mui/icons-material/Error';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import AIaudioToText from '../../../../Components/Common Components/AIaudioToText';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AICollabSummary from '../../../../Components/Common Components/AICollabSummary';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';

const SarasPatientHeader = ({ PatientData, TransmitDisable, alleryData = [], sharedData, ...props }) => {
    const [state, setState] = useState(() => {
        const userInfo = JSON.parse(localGetItem("loggedInUserInfo") || '{}');
        return {
            clinicId: localGetItem('SelectedDoctorClinicId'),
            doctorMandatory: userInfo?.token_gen_type !== "Specialization",
            disableButton: false,
            TransferPopup: false,
            TranferMethod: "Transfer Appointment",
            selectedDoc: null,
            selectedspec: null,
            comments: "",
            PurposeOfVisit: "",
            filteredDocList: [],
            Specilazation: null,
            Doctor: null,
            spcInfo: [],
            SpecializationInfo: [],
            SpecdocDetails: [],
            filterspcInfo: [],
            docDetails: [],
            POVList: [],
            PurposeOfVisit: "",
            allergyData: [],
            postTransLoad: false,
            postAppTransLoad: false,
            successPopup: false,
            successPopupTxt: '',
            smsSuccessTxt: '',
            addendumPopup: false,
            addendumLogPopup: false,
            addendumLogList: [],
            scan_status: false,
            confirmpopup: false,
            isLocked: false,
            Addcomments: "",
            notesPage: 0,
            notesPageSize: 10,
            statuspopup: false,
            patientPrimType: {},
            patientDetails: {},
            PatientData: PatientData || {},
            appointmentId: null,
            patientId: null,
            TransferDisable: false,
            AIpopup: false,
            AICollabPopup: false,
            AIGeneratedText: [],
            saveAICollabData : null,
            //template 
            templateList: [],
            selectedTemplateName: '',
            openPopupAddNew: false,
            templateLoad: false,
            tempType: '',
            templateName: '',
            tempType: '',
            deleteTemplateName: {},
            deletePopup: false,
        }
    })
    const [isWahtsAppText, setisWahtsAppText] = useState('')

    const hasMounted = useRef(false);
    const prevTransferPopup = useRef(state.TransferPopup);
    const prevPostTransLoad = useRef(state.postTransLoad);

    useEffect(() => {
        getTemplateData()
        const clinicId = localGetItem('SelectedDoctorClinicId') || '';
        const userInfo = JSON.parse(localGetItem("loggedInUserInfo") || '{}');
        const povData = localGetItem("PurposeOfVisit");
        const POVList = povData ? JSON.parse(povData).map(el => el.reason) : [];

        updateState({
            clinicId,
            doctorMandatory: userInfo?.token_gen_type !== "Specialization",
            POVList: POVList?.length > 0 ? POVList : [],
        });

        getPatientPrimaryData();
        getPatientDetailData();
        getDoctorDetails(userInfo?.doctor_id ? userInfo?.doctor_id : null);
    }, []);

    const getTemplateData = () => {
        try{
            RestAPIService.getAll(Serviceurls.SARAS_DOCNOTE_TEMPLATE)
            .then((response) => {
                if(response.data.status === 'success'){
                    updateState({
                        templateList: response.data.data
                    })
                }
            })
            .catch((e) => {
                if(e?.response?.data?.status === 'fail'){
                    props.errorMessage(e?.response?.data?.message);
                }else{
                    props.errorMessage(e?.message)
                }
            })
        }catch(e){
            props.errorMessage(e?.message)
        }
    }

    useEffect(() => {
        const patientData = JSON.parse(getCachevalue("DoctorPatientData"));

        updateState({
            PatientData: patientData,
            appointmentId: patientData?.appointment_id,
            patientId: patientData?.patient_id,
            isLocked: patientData?.transfer_appointment ? patientData?.transfer_appointment : patientData?.is_locked,
            TransferDisable: patientData?.is_transmitted ? patientData?.is_transmitted : false,
        })
    }, []);

    useEffect(() => {
        if (state.TransferPopup || state.TranferMethod) {
            getSpecInfo();
        }
    }, [state.TransferPopup, state.TranferMethod])

    useEffect(() => {
        if (state.postTransLoad) {
            PostTransfer();
        }
    }, [state.postTransLoad])

    useEffect(() => {
        if (state.postAppTransLoad) {
            postDoctorAppointmentCreate();
        }
    }, [state.postAppTransLoad])

    useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
        } else {
            const wasPreviouslyTrue = prevTransferPopup.current && prevPostTransLoad.current;
            const isNowFalse = !state.TransferPopup && !state.postTransLoad;

            if (wasPreviouslyTrue && isNowFalse) {
                clearCachevalue("DoctorPatientData");
                history.push({ pathname: "/DoctorHome" });
            }
        }

        // update previous values after the check
        prevTransferPopup.current = state.TransferPopup;
        prevPostTransLoad.current = state.postTransLoad;
    }, [state.TransferPopup, state.postTransLoad]);

    useEffect(() => {
        if (state.addendumPopup) {
            getAddendumLogData()
        }
    }, [state.addendumPopup])

    useEffect(() => {
        if (!state.addendumPopup && !state.Addcomments) {
            getDoctorPatientAppointment()
        }
    }, [state.addendumPopup, state.Addcomments])

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const history = useHistory();

    //api get functions
    const getSpecInfo = () => {
        const clinic_id = localGetItem('SelectedDoctorClinicId');
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION + `?clinic_id=${clinic_id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
                        let datas = response.data.data || [];
                        let SpecList = []
                        let Specialization = []
                        if (state.TranferMethod === "Transfer Appointment") {
                            SpecList = datas?.filter((item) => (item.is_active === true && item.id === UserData?.specialization_id))
                        } else {
                            Specialization = datas?.filter((item) => (item.is_active === true))
                        }
                        updateState({
                            spcInfo: SpecList,
                            SpecializationInfo: Specialization,
                            selectedspec: SpecList[0],
                            SpecdocDetails: state?.docDetails?.filter((item) => (item?.specialization_id === SpecList[0]?.id))
                        });
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        props.errorMessage(error?.response?.data?.message);
                    }
                });
        } catch (e) {
            props.errorMessage(e.message);
        }
    }

    const getDoctorDetails = (CurrentDocID) => {
        const clinic_id = localGetItem('SelectedDoctorClinicId');
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?clinic_id=${clinic_id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        let List = response.data.data ? response.data.data.filter((item) => (item?.doctor_id !== CurrentDocID)) : []
                        updateState({
                            docDetails: List,
                        })
                    }
                })
                .catch(error => {
                    if (error.response?.data?.status === "fail") {
                        props.errorMessage(error.response?.data?.message);
                    }
                });
        } catch (e) {
            props.errorMessage(e.message);
        }
    }

    const getAddendumLogData = () => {
        try {
            RestAPIService.getAll(Serviceurls.GET_ADDENDUM_LOG + `?appointment_id=${state.PatientData?.appointment_id}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({
                            addendumLogList: response.data?.data?.map((item, index) => ({ ...item, sno: index + 1 })) || []
                        })
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error.message);
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const lockDoctorNotes = () => {
        const { appointment_id } = state.PatientData;
        try {
            updateState({ confirmpopup: false })
            const data = {
                appointment_id: appointment_id,
                status: 'appointment lock'
            }
            RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_LOCK + `${appointment_id}/lock/`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        props.successMessage(response.data.message)
                        getDoctorPatientAppointment()
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const getDoctorPatientAppointment = () => {
        const patientData = JSON.parse(getCachevalue("DoctorPatientData"));
        const clinic_id = localGetItem('SelectedDoctorClinicId');

        try {
            RestAPIService.getAll(Serviceurls.FO_GET_APPOINMENT_DETAILS + '?clinic_id=' + clinic_id + '&appointment_id=' + patientData?.appointment_id)
                .then((response) => {
                    if (response) {
                        setCachevalue(JSON.stringify(response.data.data), 'DoctorPatientData');
                        updateState({
                            appointmentDetails: response.data.data,
                            isLocked: response.data.data?.is_locked
                        })
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const getPatientDetailData = () => {
        const patientData = JSON.parse(getCachevalue("DoctorPatientData"));
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + patientData?.patient_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        updateState({
                            patientDetails: response?.data?.data
                        })
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const getPatientPrimaryData = () => {
        const patientData = JSON.parse(getCachevalue("DoctorPatientData"));
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_PRIMARY_PAYMENT_GET + '?appointment_id=' + patientData?.appointment_id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        updateState({
                            patientPrimType: response?.data?.data
                        })
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const renderAutoComplete = (label, stateKey, showKey, list, onInputChange = false, width = "15vw") => {
        return (
            <Autocomplete
                inputProps={{ maxLength: 90 }}
                clearIcon
                freeSolo
                size='small'
                sx={{ width: width }}
                options={list}
                getOptionLabel={(options) => typeof (options) === 'string' ? options : options[showKey]}
                value={state[stateKey] || null}
                onChange={(e, newValue) => {
                    updateState({
                        [stateKey]: newValue
                    })
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        inputProps={{
                            ...params.inputProps,
                            maxLength: 90,
                        }}
                        {...(onInputChange
                            ? (event) => updateState({
                                [stateKey]: event.target.value
                            })
                            : {})}
                    />
                )}
            />
        )
    }

    const renderTextField = (label, stateKey, isMultiline = false, style = {}) => {
        return (
            <TextField
                label={label}
                multiline={isMultiline}
                style={style}
                rows={isMultiline ? 4 : null}
                value={state[stateKey] || ""}
                autoComplete="off"
                size="small"
                onChange={(e) => {
                    const { value } = e.target;
                    if (isMultiline) {
                        if (value?.length <= 250) {
                            updateState({ [stateKey]: value })
                        } else {
                            props.errorMessage('Allowed only 250 characters')
                        }
                    } else {
                        updateState({ [stateKey]: e.target.value })
                    }

                }}
            />)
    }
    
    // Transfer popup start
    const PostTransfer = () => {
        const clinic_id = getCachevalue('SelectedDoctorClinic')

        try {
            let data = {
                "clinic_id": clinic_id,
                "appointment_id": state.PatientData?.appointment_id,
                "doctor_id": state.selectedDoc?.doctor_id,
                "patient_id": state.PatientData?.patient_id,
                "transfer_notes": state.comments
            }
            if ((state.selectedDoc === null || state.selectedDoc === '') && state.doctorMandatory) {
                props.errorMessage("Kindly Select the Mandatory Fields")
            } else {
                RestAPIService.create(data, Serviceurls.DOC_TRANSFER_REQUEST)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            props.successMessage(response.data.message)
                            updateState({
                                TransferPopup: false,
                                postTransLoad: false
                            })
                        }
                    }).catch((error) => {
                        updateState({ postTransLoad: false })
                        if (error?.response?.data?.message) {
                            props.errorMessage(error.response.data.message)
                        } else {
                            props.errorMessage(error.message)
                        }
                    })
            }
        } catch (error) {
            updateState({ postTransLoad: false })
            props.errorMessage(error.message)
        }
    }

    const postDoctorAppointmentCreate = () => {
        try {
            const AptDateTime = new Date()
            const AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd')
            const Aptime = DateTime.fromJSDate(AptDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

            const clinicId = getCachevalue('SelectedDoctorClinic')
            if ((state.Doctor === '' || state.Doctor === null) && state.doctorMandatory) {
                props.errorMessage("Select Doctor")
            } else if (state.Specilazation === "" || state.Specilazation === null) {
                props.errorMessage("Select Specilazation")
            } else if (state.PurposeOfVisit === '') {
                props.errorMessage("Select Purpose of Visit")
            } else {
                const data = {
                    patient_id: state.PatientData?.patient_id,
                    doctor_id: state.Doctor?.doctor_id ? state.Doctor?.doctor_id : null,
                    speciality_id: state.Specilazation?.id ? state.Specilazation?.id : null,
                    purpose_of_visit: state.PurposeOfVisit,
                    patient_tag_id: state.selectedTagId?.id,
                    appointment_date: AptDate,
                    appointment_start_time: Aptime,
                    patient_appointment_type: state.selectedAppointTypeId === null ? null : state.selectedAppointTypeId?.id || 3,
                    nurse_id: state.selectedNurseId?.staff_id || null,
                    request_id: state.RequestedPatientData?.id || null,
                    clinic_id: +clinicId,
                    new_appointment: true,
                    transfer_appointment: true,
                    appointment_id: state.appointmentId || null,
                }
                RestAPIService.create(data, Serviceurls.DOC_PATIENT_APPOINTMENT)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            props.successMessage(response.data.message)
                            updateState({ TransferPopup: false, postAppTransLoad: false })
                            postPatientStatus()
                        }
                    }).catch((error) => {
                        updateState({ postAppTransLoad: false })
                        props.errorMessage(error?.response?.data?.message || error?.message)

                    })
            }
        } catch (error) {
            updateState({ postAppTransLoad: false })
            props.errorMessage(error.message)
        }
    }

    const postPatientStatus = (status) => {
        try {
            const clinic_id = localGetItem('SelectedDoctorClinicId');
            const UserData = JSON.parse(localGetItem("loggedInUserInfo"))
            updateState({ statuspopup: false });
            let data = {
                "appointment_id": state.PatientData?.appointment_id,
                "waiting_timer": null,
                "clinic_id": clinic_id,
            }
            if (status === "Scan/Surgery") {
                data["appointment_status"] = status;
            } else if (status === "Completed") {
                data["appointment_status"] = "Completed";
            } else {
                data = {
                    ...data,
                    "appointment_status": "Completed",
                    "is_transfered": true,
                    "transfer_doctor_id": state.Doctor?.doctor_id ? state.Doctor?.doctor_id : null,
                    "transfer_id": state?.transferId ? state?.transferId : null,
                }
            }
            RestAPIService.create(data, Serviceurls.DOC_APPOINTMENT_STATUS_UPDATE)
                .then(response => {
                    if (response.data.status == "success") {
                        updateState({ scan_status: false })
                        const smsConfig = localGetItem("smsConfig") ? JSON.parse(localGetItem("smsConfig")) : {}
                        if (status === "Completed" && (smsConfig?.appointment_completed_sms || UserData?.whatsapp_config?.doctor_visit_report)) {
                            updateState({
                                successPopup: true,
                                successPopupTxt: response.data.message,
                                smsSuccessTxt: response.data.sms_message
                            })
                            setisWahtsAppText(response.data.whatsapp_message)
                        } else {
                            history.push({ pathname: "/DoctorHome" })
                        }
                    }
                }).catch(e => {
                    props.errorMessage(e.response.data.message || e.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    const renderSuggestionDropDown = (label, stateKey, Data = []) => {
        return (
            <Autocomplete
                size='small'
                clearIcon={false}
                sx={{ width: '15vw' }}
                options={Data}
                getOptionLabel={(item) => (label === "Doctor" ? item.doctor_name : item.name)}
                value={state[stateKey]}
                onChange={(event, newValue) => {
                    let stateUpdate = { ...state, [stateKey]: newValue };

                    if (newValue !== null && "doctor_id" in newValue) {
                        let docDetail = { ...newValue };
                        docDetail["name"] = docDetail["specialization_name"];
                        delete docDetail.specialization_name;
                        docDetail["id"] = docDetail["specialization_id"];
                        delete docDetail.specialization_id;
                        stateUpdate["Specilazation"] = docDetail;
                    }

                    if (newValue !== null && "name" in newValue) {
                        let filteredLst = stateUpdate["docDetails"]?.length > 0 && stateUpdate["docDetails"].filter(item => item["specialization_id"] === newValue["id"]);
                        stateUpdate["filteredDocList"] = filteredLst?.length > 0 ? filteredLst : [];
                        stateUpdate["Doctor"] = null;
                    }

                    if (newValue === null && label === "Specialization") {
                        stateUpdate["filteredDocList"] = stateUpdate["docDetails"];
                    }

                    updateState(stateUpdate);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label + `${(label === "Doctor" && state.doctorMandatory || label === "Specialization") ? " *" : ""}`}
                        placeholder={label}
                    />
                )}
            />
        )
    }

    const renderTransferAppointPopup = () => {
        return (
            <div>
                <Modal open={state.TransferPopup}>
                    <Box component={"div"} className='eMed_Doc_Notes_Counsellor_Pop_Up' style={{ width: "33vw", height: "60vh", maxHeight: "100%" }}>
                        <Box component={'div'} p={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontWeight={600}>Transfer Appointment</Typography>
                            {renderIconButton("Close", ImagePaths.LabCloseButton.default,
                                () => updateState({
                                    TransferPopup: false, TranferMethod: "Transfer Appointment",
                                    selectedDoc: null, selectedspec: null, comments: "", PurposeOfVisit: ""
                                }),
                                false, "1vw"
                            )}
                        </Box>
                        <Box component={'div'}>
                            <Box component={'div'} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                <RadioGroup value={state.TranferMethod}
                                    sx={{ display: 'flex', flexDirection: 'row', marginTop: "0.65vw" }}
                                    onClick={(e) => { updateState({ TranferMethod: e.target.value, selectedspec: null, selectedDoc: null, filteredDocList: [], Specilazation: null, Doctor: null, PurposeOfVisit: "" }) }}
                                >
                                    <FormControlLabel value={'Transfer Appointment'} control={<Radio size='small' />} label='Transfer Doctor' />
                                    <FormControlLabel value={'New Appointment'} control={<Radio size='small' />} label='Transfer Appointment' />
                                </RadioGroup>
                            </Box>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%", marginTop: "0.5vw", marginBottom: "0.5vw" }}>
                                <div style={{ marginLeft: "1vw", marginTop: "0.65vw" }}>
                                    {state?.TranferMethod === "Transfer Appointment" ?
                                        renderAutoComplete('Specialization *', "selectedspec", "name", state.spcInfo)
                                        : renderSuggestionDropDown("Specialization", "Specilazation", state.SpecializationInfo)
                                    }
                                </div>
                                <div style={{ marginLeft: "1vw", marginTop: "0.65vw" }}>
                                    {state?.TranferMethod === "Transfer Appointment" ?
                                        renderAutoComplete(state.doctorMandatory ? 'Doctor *' : 'Doctor', "selectedDoc", "doctor_name", state.SpecdocDetails)
                                        : renderSuggestionDropDown("Doctor", "Doctor", state.filteredDocList?.length > 0 ? state.filteredDocList : state.docDetails)
                                    }
                                </div>
                            </div>
                            {state.TranferMethod == "New Appointment" && <Box sx={{ paddingLeft: "1vw", paddingBottom: "0.5vw" }}>
                                {renderAutoComplete("Purpose Of Visit *", "PurposeOfVisit", "", state.POVList, true, "31vw")}
                            </Box>}
                            <div style={{ fontWeight: 600, marginLeft: "0.5vw", color: Colors.SecondaryText }}>Notes</div>
                            <div style={{ height: "10vw", width: "95%", paddingLeft: "1vw" }}>
                                {renderTextField("Enter Description", "comments", true, { height: "8vw", marginTop: "0.75vw", width: "100%" })}
                            </div>
                            <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'} gap={"0.5vw"}>
                                <ActionButton text="Cancel" emed_tid='transfer_doc_notes'
                                    onClick={() => { updateState({ TransferPopup: false, TranferMethod: "Transfer Appointment", selectedDoc: null, selectedspec: null, comments: "", PurposeOfVisit: "" }) }}
                                />
                                <ActionButton text={state.TranferMethod === "Transfer Appointment" ? 'Transfer' : 'create Appointment'} emed_tid='transfer_doc_notes'
                                    onClick={() => { state.TranferMethod === "Transfer Appointment" ? updateState({ postTransLoad: true }) : updateState({ postAppTransLoad: true }) }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Modal>
            </div >
        )
    }
    // Transfer popup end

    // Addendum Popup start
    const PostAddendum = () => {
        try {
            const data = {
                addendum_notes: state.Addcomments,
                appointment_id: state.PatientData?.appointment_id,
            }
            RestAPIService.create(data, Serviceurls.GET_ADDENDUM_LOG)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        props.successMessage(response.data.message)
                        updateState({ addendumPopup: false, Addcomments: "" }, () => {
                            getDoctorPatientAppointment()
                        })
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const renderaddendumPopup = () => {
        return (
            <div>
                <Modal open={state.addendumPopup}>
                    <Box component={"div"} className='eMed_Doc_Notes_Counsellor_Pop_Up' style={{ width: "33vw", height: "40vh", maxHeight: "100%" }}>
                        <Box component={'div'} p={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontSize={'0.9vw'} fontWeight={600}>Addendum</Typography>
                            {renderIconButton("Close", ImagePaths.LabCloseButton.default,
                                () => updateState({ addendumPopup: false, Addcomments: "" }),
                                false, "1vw"
                            )}
                        </Box>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", margin: "0vw 1vw" }}>
                            <div style={{ fontWeight: 600, color: Colors.SecondaryText }}>Reason</div>
                            {state.addendumLogList?.length > 0 ? <div className="eMed_icon_styles"
                                style={{ backgroundColor: !props.isLocked ? Colors.ThemeColor : Colors.disableComponentColor }}
                                onClick={() => { updateState({ addendumLogPopup: true }) }}>
                                <Tooltip placement='top' title='Addendum Log'>
                                    <Box component={'img'} src={ImagePaths.View.default} height={'1.5vw'} width={'1.5vw'} />
                                </Tooltip>
                            </div> : null}
                        </div>
                        <div style={{ height: "10vw", width: "95%", paddingLeft: "1vw" }}>
                            {renderTextField("Enter Description", "Addcomments", true, { height: "8vw", marginTop: "0.75vw", width: "100%" })}
                        </div>
                        <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'} gap={"0.5vw"}>
                            <ActionButton text="Cancel" emed_tid='transfer_doc_notes'
                                onClick={() => { updateState({ addendumPopup: false, Addcomments: "" }) }}
                            />
                            <ActionButton text={'Addendum'} emed_tid='transfer_doc_notes'
                                onClick={() => {
                                    if (state.Addcomments != "") {
                                        PostAddendum()
                                    } else {
                                        props.errorMessage('Enter Addendum Comments')
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </Modal>
            </div>
        )
    }
    // Addendum Popup end

    // Addendum log popup start
    const renderAddendumLogPopup = () => {
        const columns = [
            { field: 'sno', headerName: 'S.No', flex: 0.05 },
            {
                field: 'created_by', headerName: 'Created By', flex: 0.25,
                renderCell: (params) => {
                    let createdBy = params?.row?.created_by
                    return (
                        <Box>{createdBy ? createdBy?.length > 20 ?
                            <Tooltip placement='top' title={createdBy} arrow>
                                <Typography>{createdBy?.slice(0, 20) + '...'}</Typography>
                            </Tooltip> :
                            <Typography>{createdBy}</Typography> : '-'}</Box>
                    )
                }
            },
            {
                field: 'created_date', headerName: 'Created Date & Time', flex: 0.25,
                renderCell: (params) => {
                    let createdDate = formatDateTime(params?.row?.created_date)
                    return (
                        <Box>{createdDate ? createdDate?.length > 20 ?
                            <Tooltip placement='top' title={createdDate} arrow>
                                <Typography>{createdDate?.slice(0, 20) + '...'}</Typography>
                            </Tooltip> :
                            <Typography>{createdDate}</Typography> : '-'}</Box>
                    )
                }
            },
            {
                field: 'notes', headerName: 'Notes', flex: 0.45,
                renderCell: (params) => {
                    let notes = params?.row?.notes
                    return (
                        <Box>{notes ? notes?.length > 40 ?
                            <Tooltip placement='top' title={notes} arrow>
                                <Typography>{notes?.slice(0, 40) + '...'}</Typography>
                            </Tooltip> :
                            <Typography>{notes}</Typography> : '-'}</Box>
                    )
                }
            },
        ]
        return (
            <div>
                <Modal open={state.addendumLogPopup}>
                    <Box component={"div"} className='eMed_Doc_Notes_Counsellor_Pop_Up' style={{ width: "45vw", height: "65vh", display: "flex", flexDirection: "column" }}>
                        <Box component={'div'} p={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontSize={'0.9vw'} fontWeight={600}>Addendum Log</Typography>
                            {renderIconButton("Close", ImagePaths.LabCloseButton.default,
                                () => updateState({ addendumLogPopup: false }),
                                false, "1vw"
                            )}
                        </Box>
                        <Box component={'div'} p={'0.5rem'} sx={{ flexGrow: 1, overflowY: "auto" }}>
                            <DataGrid
                                rows={state.addendumLogList}
                                page={state.notesPage}
                                columns={columns}
                                hideFooterSelectedRowCount
                                getRowId={(row) => row.sno}
                                pageSize={state.notesPageSize}
                                onPageChange={(newPage) => { updateState({ notesPage: newPage }) }}
                                onPageSizeChange={(newPageSize) => updateState({ notesPageSize: newPageSize })}
                                rowsPerPageOptions={[10, 20, 30]}
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                components={{
                                    NoRowsOverlay: () => (
                                        <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {'No Records To Be Shown'}
                                        </Box>
                                    )
                                }}
                                headerHeight={40}
                            />
                        </Box>
                    </Box>
                </Modal>
            </div>
        )
    }
    // Addendum log popup end

    // status popup start
    const ClosesuccessPopUp = () => {
        updateState({
            successPopup: false
        })
        history.push({ pathname: "/DoctorHome" })
    }

    const renderSuccessPopup = () => {
        const userData = JSON.parse(localGetItem("loggedInUserInfo"))
        return (
            <div>
                <Modal
                    open={true}
                >
                    <Box component={'div'} className="eMed_Bill_Success_Preview_Main" height={'30vh'}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2vw' }}>
                            <Box sx={{ display: 'flex', gap: '1vw' }}>
                                <img className='' src={ImagePaths.Tick.default} />
                                <Typography fontWeight={600}>{state.successPopupTxt ? state.successPopupTxt : 'Appointment Completed Successfully'}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: '1vw' }}>
                                {state.smsSuccessTxt ? <ErrorIcon color='error' /> : <img src={ImagePaths.Tick.default} alt='success' />}
                                <Typography fontWeight={600}>{state.smsSuccessTxt ? state.smsSuccessTxt : 'SMS Sent Successfully'}</Typography>
                            </Box>
                            {(userData?.whatsapp_configuration && isWahtsAppText !== '') ? <Box sx={{ display: 'flex', gap: '1vw' }}>
                                {<img src={ImagePaths.Tick.default} alt='success' />}
                                <Typography fontWeight={600}>{isWahtsAppText || 'WhatsApp Message Sent Successfully'}</Typography>
                            </Box> : null}
                        </Box>
                        <Box display={'flex'} gap={'0.5vw'}>
                            <ActionButton text="OK" emed_tid='transfer_doc_notes' variant="outlined"
                                onClick={ClosesuccessPopUp}
                            />
                        </Box>
                    </Box>
                </Modal>
            </div>
        )
    }
    // status popup end 

    const statusChange = () => {
        if (state?.scan_status) {
            postPatientStatus("Scan/Surgery")
        } else {
            postPatientStatus("Completed")
        }
    }
    const CloseAIPopUp = () => {
        setState({
            ...state,
            AIpopup: false,
            AICollabPopup: false,
        })
    }

    const errorMessage = (msg) => {
        props.errorMessage(msg)
    }

    const saveAICollabData = (data) => {
        setState({
            ...state,
            saveAICollabData: data,
        })
        props?.AIGeneratedText([]);
    }

    const transformTextFromAI = (data) => {
        setState({
            ...state,
            AIGeneratedText: data,
            AIpopup: false,
            AICollabPopup: false
        })
        props?.AIGeneratedText(data);
    }

    const renderPrimarydetails = () => {
        const { patientPrimType } = state;
        return patientPrimType?.insurance_company_name
            ? renderCorpInsuranceCard("Insurance Details", patientPrimType.insurance_company_name)
            : patientPrimType?.employer_name
                ? renderCorpInsuranceCard("Corporate Details", patientPrimType.employer_name, '11dvw')
                : null;
    }

    const stripHtml = (html) => html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();

    const consultant = {
        lineOne: "Consultant Name",
        lineTwo: `${state.PatientData?.doctor_name != null ? state.PatientData?.doctor_name : '-'}`,
    }

    const TemplateActionButton = ({ label, onClick }) => (
            <Button
                color="primary"
                fullWidth
                sx={{ justifyContent: 'flex-start', pl: 2, textTransform: 'capitalize' }}
                onMouseDown={(e) => {
                    e.preventDefault();
                    onClick();
                }}
            >
                {label}
            </Button>
        );

    useEffect(() => {
        if (state.selectedTemplateName?.id) {
            postTemplateData();
        }
    }, [state.selectedTemplateName]);

    const renderTemplate = () => {
            return (<Autocomplete
                clearIcon
                size="small"
                disabled={state.PatientData?.is_transmitted || state.PatientData?.transfer_appointment || state.isLocked || state.PatientData?.appointment_status === "Completed"}
                sx={{ width: '14vw', marginRight:'0.3vw' }}
                options={state.templateList}
                value={state.selectedTemplateName}
                getOptionLabel={(option) => typeof option === 'string' ? option : option?.name}
                onChange={(e, value) => {
                    updateState({
                        selectedTemplateName: value,
                    });
                }}
                renderOption={(props, option) => (
                    <li {...props} style={{ padding: '0vh 1.5vh' }}>
                        <ListItem sx={{ display: 'flex', justifyContent: 'space-between', p: 0, m: 0 }}>
                            <ListItemText
                                primary={
                                    option?.name?.length > 30 ? (
                                        <Tooltip title={option.name} placement="top">
                                            <div>{option.name.slice(0, 21) + '...'}</div>
                                        </Tooltip>
                                    ) : (
                                        option.name
                                    )
                                }
                            />
                            <Tooltip title="Delete Template" placement="top" arrow>
                                <IconButton
                                    edge="end"
                                    color="error"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        updateState({
                                            tempType: 'delete',
                                            deleteTemplateName: option,
                                            deletePopup: true,
                                        })
                                    }}
                                >
                                    <DeleteIcon sx={{ height: '2.5vh', width: '2.5vw' }} />
                                </IconButton>
                            </Tooltip>
                        </ListItem>
                    </li>
                )}
                renderInput={(params) => <TextField {...params} label="Select Template" />}
                PaperComponent={({ children }) => (
                    <Paper sx={{ maxHeight: '25vw', overflow: 'auto' }}>
                        {children}
                        <Divider />
                        <TemplateActionButton
                            label="Save As Template"
                            onClick={() => updateState({ openPopupAddNew: true, templateLoad: false, tempType: 'Add' })}
                        />
                        {state.selectedTemplateName && (
                            <TemplateActionButton
                                label="Edit Template"
                                onClick={() =>
                                    updateState({
                                        openPopupAddNew: true,
                                        templateLoad: false,
                                        tempType: 'rename',
                                        templateName: state.selectedTemplateName.name,
                                    })
                                }
                            />
                        )}
                    </Paper>
                )}
            />)
        }

    const postNewTemplateData = () => {
        try {
            updateState({ templateLoad: true })
            props.istemplate(true)
            const data = {
                name: state.templateName || '',
                appointment_id: state.PatientData?.appointment_id
            };

            if (!state.templateName) {
                props.errorMessage("Please enter template name");
                updateState({ templateLoad: false });
                return;
            }
            if (state.tempType === 'rename') {
                data['id'] = state.selectedTemplateName?.id
                RestAPIService.updateWithOutId(data, Serviceurls.SARAS_DOCNOTE_TEMPLATE)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            props.successMessage("Template renamed successfully");
                            updateState({
                                templateLoad: false,
                                openPopupAddNew: false,
                                templateName: '',
                                selectedTemplateName: '',
                                isEdit: false
                            });
                            getTemplateData();
                            props.istemplate(false)
                        }
                    })
                    .catch((error) => {
                        updateState({ templateLoad: false });
                                    props.istemplate(false)
                        props.errorMessage(error?.response?.data?.message || error.message);
                    });
            }

            else {
                RestAPIService.create(data, Serviceurls.SARAS_DOCNOTE_TEMPLATE)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            props.successMessage(response.data.message)
                            updateState({
                                templateLoad: false,
                                openPopupAddNew: false,
                                templateName: '',
                                selectedTemplateName: '',
                                isEdit: false
                            })
                            getTemplateData()
                            props.istemplate(false)
                        }
                    })
                    .catch((error) => {
                        updateState({ templateLoad: false });
                        props.errorMessage(error?.response?.data?.message || error.message);
                    });
            }
        } catch (error) {
            updateState({ templateLoad: false });
            props.errorMessage(error.message);
        }
    };
    const postTemplateData = () => {
        try {
            updateState({ templateLoad: true })
            props.istemplate(true)
            const data = {
                "template_id": state.selectedTemplateName?.id || null,
                "appointment_id": state.PatientData?.appointment_id
            }
            RestAPIService.create(data, Serviceurls.SARAS_DOCNOTE_TEMPOST)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        props.successMessage(response.data.message)
                        props.istemplate(false)
                    }
                }).catch((error) => {
                    updateState({ templateLoad: false })
                    props.istemplate(false)
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ templateLoad: false })
            props.istemplate(false)
            props.errorMessage(error.message)
        }
    }
    const deleteTemplateData = () => {
        try {
            updateState({ removeData: true });
            RestAPIService.delete(`${Serviceurls.SARAS_DOCNOTE_TEMPLATE}?id=${state.deleteTemplateName?.id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        props.successMessage(response.data.message);
                        updateState({
                            openPopupAddNew: false,
                            templateLoad: false,
                            deleteTemplateName: {},
                            selectedTemplateName: '',
                            deletePopup: false,
                            removeData: false,
                            isEdit: false
                        });
                        getTemplateData();
                    }
                })
                .catch(e => {
                    updateState({ removeData: false });
                    props.errorMessage(e.response.data.message || e.message)
                });
        } catch (e) {
            updateState({ removeData: false });
            props.errorMessage(e.message);
        }
    }
    return (
        <Box component={'div'} marginLeft={'0.5vw'} className='eMed_patient_header'>
            <Box className="eMed_OtherDocNotes_Header">
                <Box display={'flex'} alignItems='center'>
                    <Box className='eMed_Patient_Details_Long eMed_patient_box'>
                        <CommonPatientDetails data={state.PatientData} showDetailed={true} fromDoctor={true} hideInsurance={true} />
                    </Box>
                    <ConsultantPatientCard name={consultant} width={"15dvw"} />
                    <Box component={'div'} onClick={() => { history.push({ pathname: "/DoctorHome/Reports/DoctorVisit" }) }} className='doc_header_card' sx={{ width: "6vw", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }} mr={'0.5vw'}>
                        <Box component={'img'} src={ImagePaths.PreviousPrescription.default} height={'1.8vw'} width={'1.8vw'} />
                        <div style={{ fontSize: "0.85vw" }}>Visit Log</div>
                    </Box>
                    {(alleryData && alleryData?.length > 0) && (!alleryData?.some((item) => item.allergy_type === 3)) &&
                        <Tooltip placement='top' title={alleryData?.map(item => item.name).join(",")} arrow>
                            <Box component={'div'} className='doc_header_card' sx={{ width: "5vw", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }} mr={'0.5vw'}>
                                <Box component={'img'} src={ImagePaths.AllergyAlert.default} height={'2vw'} width={'2vw'} />
                                <div style={{ fontSize: "0.7vw" }}>Allergy</div>
                            </Box>
                        </Tooltip>}
                    {renderPrimarydetails()}
                </Box>
                {renderTemplate()}
                <Box display={"flex"} justifyContent={"center"} alignItems={"center"} columnGap={"0.3vw"} marginRight={"0.3vw"}>
                    <ActionButton text="Transfer" emed_tid='transfer_doc_notes'
                        disabled={TransmitDisable || state.PatientData?.is_transmitted || state.PatientData?.transfer_appointment || state.isLocked || state.PatientData?.appointment_status === "Completed"}
                        onClick={() => { updateState({ TransferPopup: true }) }}
                    />
                    <ActionButton text={state.isLocked ? "Addendum" : "Lock"} emed_tid={state.isLocked ? "addendum_doc_notes" : "lock_doc_notes"}
                        disabled={state.isLocked ? localGetItem('DoctorNotesLock') === 'false' : false}
                        onClick={() => { state.isLocked ? updateState({ addendumPopup: true }) : updateState({ confirmpopup: true }) }}
                    />
                    <ActionButton text="Complete" emed_tid='complete_doc_notes'
                        disabled={state.PatientData?.appointment_status === "Completed" || state.isLocked || state.PatientData?.transfer_appointment}
                        onClick={() => { updateState({ statuspopup: true }) }}
                    />
                    {localGetItem("enable_ai_doctor_notes") === "true" ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Tooltip title={props?.AIDocNotesKeys?.message || ""} placement="top" arrow>
                                <ReportGmailerrorredIcon color={props?.AIDocNotesKeys?.threshold_met ? 'error' : "primary"} />
                            </Tooltip>

                            {/* More Menu */}
                            <Box>
                                <IconButton
                                    aria-controls="ai-menu"
                                    aria-haspopup="true"
                                    onClick={(e) => updateState({ aiMenuAnchor: e.currentTarget })}
                                >
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu
                                    id="ai-menu"
                                    anchorEl={state.aiMenuAnchor}
                                    open={Boolean(state.aiMenuAnchor)}
                                    onClose={() => updateState({ aiMenuAnchor: null })}
                                >
                                    <MenuItem
                                        onClick={() => {
                                            updateState({ AIpopup: true, aiMenuAnchor: null });
                                        }}
                                        disabled={
                                            state.isLocked ||
                                            state.PatientData?.appointment_status === "Completed" ||
                                            props?.AIDocNotesKeys?.limit_reached
                                        }
                                    >
                                        <GraphicEqIcon fontSize="small" sx={{ mr: 1 }} />
                                        AI Doctor Notes
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            updateState({ AICollabPopup: true, aiMenuAnchor: null });
                                        }}
                                        disabled={
                                            state.isLocked ||
                                            state.PatientData?.appointment_status === "Completed" ||
                                            props?.AIDocNotesKeys?.limit_reached
                                        }
                                    >
                                        <AutoAwesomeIcon fontSize="small" sx={{ mr: 1 }} />
                                        AI Collaborative Summary
                                    </MenuItem>
                                </Menu>
                            </Box>
                        </Box>
                    ) : null}
                </Box>
            </Box>
            {renderTransferAppointPopup()}
            {renderaddendumPopup()}
            {renderAddendumLogPopup()}
            {state.successPopup && renderSuccessPopup()}
            {state.confirmpopup &&
                <ConfirmPopup
                    cnfTitle={'Confirmation'}
                    cnfContent={'Are you sure, Do you want to Lock Doctor Notes'}
                    cnfAlertPopupClose={() => { updateState({ confirmpopup: false }) }}
                    cnfData={lockDoctorNotes.bind(this)}
                />}
            {state.statuspopup &&
                <ConfirmPopup
                    cnfTitle={'Confirmation'}
                    cnfContent={'Are you sure, Do you want to change status'}
                    cnfAlertPopupClose={() => { updateState({ statuspopup: false }) }}
                    cnfData={statusChange.bind(this)}
                />}
            {state.AIpopup &&
                <AIaudioToText
                    transformText={transformTextFromAI.bind(this)}
                    ClosePopUp={CloseAIPopUp.bind(this)}
                    PatientData={state.PatientData}
                />}
            {state.AICollabPopup &&
                <AICollabSummary
                    ClosePopUp={CloseAIPopUp.bind(this)}
                    errorMessage={errorMessage.bind(this)}
                    saveAICollabData={saveAICollabData.bind(this)}
                    AICollabData={state?.saveAICollabData}
                    PatientData={state.PatientData}
                />}
            {state.openPopupAddNew && <TemplatePopup
                open={state.openPopupAddNew}
                Title={'Doctor Notes'}
                onClose={() => updateState({ openPopupAddNew: false, templateLoad: false, templateName: "", tempType: '' })}
                templateName={state.templateName || ''}
                setTemplateName={(value) => updateState({ templateName: value })}
                tempType={state.tempType}
                onSubmit={postNewTemplateData}
                loading={state.templateLoad}
            />}
            {state.deletePopup && <DeletePopup
                DeletTitle={`Are you sure you want to delete ${state.deleteTemplateName?.name} ?`}
                deleteAlertPopupClose={() => { updateState({ deletePopup: false, isDeleteCliked: false }) }}
                removeData={deleteTemplateData.bind(this)}
                disable={state.removeData}
            />}
        </Box>
    )
}

export default SarasPatientHeader